import { notifications } from '@mantine/notifications';
import messages from '../../../shared/constants/messages';
import { UpdateOrderState } from '../type';

const removeItemById = (state: UpdateOrderState, id: string): UpdateOrderState => {
  const orderOrderItems = state?.updatedOrder?.orderItems
    ?.filter((x) => x.id !== id)
    .reduce((acc, cur) => acc + (cur?.count || 0), 0);
  if (orderOrderItems === 0) {
    notifications.show({
      message: messages.NOT_ALLOW_REMOVE_ALL_ITEMS,
      color: 'red',
    });
    return state;
  }
  return {
    ...state,
    updatedOrder: {
      ...state?.updatedOrder,
      orderItems: state?.updatedOrder?.orderItems?.filter((x) => x.id !== id),
    },
    removedItems: [
      ...(state?.removedItems || []),
      ...(state?.order?.data?.orderItems?.filter((x) => x.id === id) || []),
    ],
  };
};

export default removeItemById;
